<!-- 
    COMPONENTE PARA INCLUSAO DE ANOTACOES EM NEGOCIO, ORGANIZACAO OU PESSOA
-->

<script>
import Vue from 'vue';
import { SysVars } from '../main';
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        params: {},
    },
    
    components: {
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            addingNote: false,
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {

        notes: function () {
            return this.params.notes
        },

    },

    methods: {
        handleIncluirObs () {
            this.texto = null
            this.addingNote = true
            this.$nextTick(function () {
                this.$refs.texto.focus()
            })
        },
        handleEditObs (index) {
            this.$set(this.notes[index], 'editing', true)
            this.texto = this.notes[index].texto
            // this.$nextTick(function () {
            //     this.$refs.texto.focus()
            // })
        },
        handleDeleteObs (index) {
            if (confirm("Confirma a exclusão?")) {
                this.apiNotesDelete(this.notes[index].codnote).then(
                    this.notes.splice(index, 1)
                )
            }
        },
        handlePutObs (index) {
            if (!this.texto)
                return
            let note = this.notes[index]
            note.texto = this.texto
            this.indexNote = index
            this.apiNotes(note, note.codnote, this.callBackNote)
        },
        handlePostObs (texto) {
            if (!this.texto) {
                return
            }
            let note = { texto: this.texto, codnegocio: this.params.codnegocio, codorg: this.params.codorg, codpessoa: this.params.codpessoa, codlead: this.params.codlead }
            this.apiNotes(note, null, this.callBackNote)
        },
        handleCancelObs (index) {
            if (index >= 0) 
                this.notes[index].editing = false
            else
                this.addingNote = false
        },
        callBackNote (data) {
            if (data) {
                if (this.addingNote) 
                    this.notes.push(data)
                else {
                    this.notes[this.indexNote].texto = data.texto
                    this.notes[this.indexNote].editing = false
                }
                this.addingNote = false
                this.indexNote = null
            }
        },
    },

    watch: {

    },

    mounted () {
    },

    created () {

    }

}

</script>

<template>
<div>
    <div class="w-100">
        <span class="lbl-deal-subtitle"><i class="fa fa-edit pr-2"></i>ANOTAÇÕES</span>
        <v-button label="Adicionar" :link="true" icon="fa-plus" :nb-btdef="false" @click="handleIncluirObs"></v-button>

        <div v-if="addingNote" class="col-12 mt-4 mb-5">
            <form-field ref="texto" v-model="texto" type="memo" col="12"></form-field>
            <div class="col-12">
                <v-button label="Cancelar" @click="handleCancelObs"></v-button>
                <v-button label="Salvar" :success="true" icon="fa-download" @click="handlePostObs"></v-button>
            </div>
        </div>
    </div>
    <div class="w-100" v-for="(item, index) in notes" :key="index">
        <div class="card p-2 mt-2">
            <div class="w-100 mb-2" v-if="!item.editing">
                    <span class="lbl-list pr-2 mb-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.data | formatDataHoraExtenso }}</span>
                    <span class="lbl-list pr-2 mb-3"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ item.usuario_nome }}</span>
                    <v-button :link="true" icon="fa-trash" class="float-right" @click="handleDeleteObs(index)"></v-button>
                    <v-button :link="true" icon="fa-pencil" class="float-right" @click="handleEditObs(index)"></v-button>
                    <span class="data-list w-100">{{ item.texto }}</span>
            </div>
            <div class="w-100" v-if="item.editing">
                <form-field ref="texto" v-model="texto" type="memo" col="12"></form-field>
                <div class="w-100">
                    <v-button label="Cancelar" @click="handleCancelObs(index)"></v-button>
                    <v-button label="Salvar" :success="true" icon="fa-download" @click="handlePutObs(index)"></v-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-notes.vue